import React, { Fragment, useState, useRef } from "react";
import PropTypes from "prop-types";

import Medication from "./Medication";
import Icon from "../Icon";

const sortMedsByName = (medications) => {
  return medications.sort(
    (a, b) =>
      (a.Name.toLowerCase() > b.Name.toLowerCase()) -
      (a.Name.toLowerCase() < b.Name.toLowerCase())
  );
};

const List = ({ items }) => {
  return (
    <ol className="MedicationLetter-items">
      {sortMedsByName(items).map((result, i) => (
        <li key={i} className="MedicationLetter-item">
          <Medication key={i} medication={result} />
        </li>
      ))}
    </ol>
  );
};

const MedicationByLetter = ({ letter, medications }) => {
  const [expanded, setExpanded] = useState(false);
  const elRef = useRef(null);

  const previewCount = 15;
  const preview = medications.slice(0, previewCount);

  const buttonHandler = () => {
    if (expanded) {
      elRef.current.scrollIntoView();
    }
    setExpanded(!expanded);
  };

  const Button = () => {
    return (
      <Fragment>
        {medications.length > previewCount && (
          <div className="u-center">
            <button
              className="MedicationLetter-expand"
              type="button"
              onClick={buttonHandler}
            >
              <span className="MedicationLetter-expand-iconWrapper">
                <Icon
                  className="MedicationLetter-expand-icon"
                  width="20"
                  height="20"
                  name={expanded ? "minus" : "plus"}
                />
              </span>
              Show {expanded ? "Less" : "More"}
              <span className="u-screenreader">
                medications that begin with {letter}
              </span>
            </button>
          </div>
        )}
      </Fragment>
    );
  };

  return (
    <div ref={elRef} className="MedicationLetter">
      <p className="f-h2 u-mb1">{letter}</p>
      <List items={expanded ? medications : preview} />
      <Button />
    </div>
  );
};

MedicationByLetter.propTypes = {
  letter: PropTypes.string.isRequired,
  medications: PropTypes.array.isRequired,
};

export default MedicationByLetter;